<template>
    <b-container fluid>
        <b-alert :show="errors.any()" variant="danger" class="px-4">
            <ul class="m-0 px-1">
                <li v-for="err in errors.all()" :key="err">{{err}}</li>
            </ul>
        </b-alert>
        <b-row class="justify-content-center">
            <b-col cols="10" class="text-center">
                <p class="h5 font-weight-bold">Confirm phone number to text</p>
                <div v-if="fromReport">

                    <p v-if="orderType === 'Dine In'">
                        Ask customer to pay as soon as they receive the payment link.
                    </p>
                    <p v-else>
                        Pickup/Delivery time is tentative and will be pushed or order will be cancelded if payment is delayed.
                    </p>
                </div>
                <div v-else>
                    <p v-if="orderType === 'DineIn'">
                        Ask customer to pay as soon as they receive the payment link.
                    </p>
                    <p v-if="orderType !== 'DineIn'">
                        Pickup/Delivery time is tentative and will be pushed or order will be cancelded if payment is delayed.
                    </p>
                </div>

                <div class="mb-3">
                    <b-input-group :prepend="'Phone Number'">
                        <b-input-group-append>
                            <b-input-group-text class="bg-white" :class="'border-left-0'">
                                +1
                            </b-input-group-text>
                        </b-input-group-append>
                        <b-input v-model="getPhoneNumber" v-mask="'###-###-####'" :decimal="false" :name="'Phone Number'" v-validate="`required`"/>
<!--                        <b-input :name="'Phone Number'" v-model="getPhoneNumber" v-validate="'required'"/>-->
                    </b-input-group>
                </div>
                <div v-if="!fromReport">
                    <b-btn class="font-weight-bold" variant="warning" @click="GetOrderPaymentURL" :disabled="loading">
                        Text Payment Link
                    </b-btn>
                    <b-btn variant="warning" class="font-weight-bold mx-2" @click="cancelOperation" v-if="fromReport">
                        Cancel
                    </b-btn>
                </div>
                <div v-else class="grayDisable">
                    <b-btn class="font-weight-bold" variant="warning" @click="GetOrderPaymentURL" :disabled="loading || !getPhoneNumber">
                        Text Payment Link
                        <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                    </b-btn>
                    <b-btn variant="warning" class="font-weight-bold mx-2" @click="cancelOperation" v-if="fromReport">
                        Cancel
                    </b-btn>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {urlShortner} from '../../lib/urlShortener'
    import NumericInput from "../shared/NumericInput";
    export default {
        components: {NumericInput},
        name: "confirmPhoneNumber",
        props: {
            orderType: {require: true},
            CreateOrderModel: {require: true},
            noCreateTab: {default: false},
            fromReport: {default: false},
            TabNumber: {required: true},
            updateOrderTime: {required: false},
            getDate: {required: false}
        },
        data () {
            return {
                loading: false,
                OrderID: null,
                url: null,
                shortUrl: null,
                tabNo: this.TabNumber,
                phoneNumber: this.CreateOrderModel.phoneNumber
            }
        },
        computed: {
            getPhoneNumber: {
                get(){
                    if (!this.phoneNumber) {
                        return ''
                    } else {
                        const phoneNumber = this.phoneNumber.replace('+1', '')
                        return phoneNumber
                    }
                    // if (!this.CreateOrderModel.phoneNumber) {
                    //     return ''
                    // } else {
                    //     const phoneNumber = this.CreateOrderModel.phoneNumber.replace('+1', '')
                    //     return phoneNumber
                    // }
                },
                set(val) {
                    if (val) {
                        this.phoneNumber = `+1${val}`
                    } else {
                        this.phoneNumber = null
                    }
                }
            }
        },
        mounted() {
            // if (!this.noCreateTab) {
            //     this.createTab()
            // }
        },
        methods: {
            makeid (length) {
                var result           = '';
                var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for ( var i = 0; i < length; i++ ) {
                    result += characters.charAt(Math.floor(Math.random() *
                        charactersLength));
                }
                return result;
            },
            createTab () {
                this.loading = true
                return this.$api.getRestaurant.CreateOrder(this.CreateOrderModel).then(res => {
                    // this.loading = false
                    if (res.success) {
                        this.OrderID = res.orderInfo.OrderID
                        this.tabNo = res.orderInfo.TabNo
                        return res
                    } else {
                        this.$showError('faild')
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            GetOrderPaymentURL () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        this.loading = true
                        if (!this.noCreateTab) {
                            this.createTab().then(() => {
                                this.createUrl()
                            })
                        } else {
                            this.loading = true
                            this.createUrl()
                        }
                    }
                })
            },
            createUrl () {
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    PhoneNumber: '+1' + (this.getPhoneNumber.replace(/-/g, '')),
                    OrderID: this.fromReport ? this.CreateOrderModel.OrderID : this.OrderID
                }
                this.$api.getRestaurant.GetOrderPaymentURL(model).then(res => {
                    if (res.success) {
                        this.url = this.$config.websiteUrl + '/' + res.results
                        this.SendPaymentURL()
                        // this.createShortUrl(this.url)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            createShortUrl (destination) {
                let slashtag = 'bpay' + this.makeid(5)
                let payload = {
                    destination,
                    domain: { fullName: "menupoly.link" },
                    slashtag
                }

                urlShortner(payload).then(res => {
                    this.shortUrl = res.data.shortUrl
                    let id = res.data.id
                    this.UpdateOrderRebrandlyPaymentURL(id)
                }).catch(err => {
                    this.loading = false
                })
            },
            UpdateOrderRebrandlyPaymentURL (RebrandlyPayment) {
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    RebrandlyPayment,
                    OrderID: this.fromReport ? this.orderType.OrderID : this.OrderID
                }
                this.$api.diner.UpdateOrderRebrandlyPaymentURL(model).then(res => {
                    if (res.success) {
                        this.SendPaymentURL()
                    } else {

                    }
                }).catch(err => {
                    this.loading = false
                })
            },
            SendPaymentURL () {
                let model = {
                    PhoneNumber: '+1' + (this.getPhoneNumber.replace(/-/g, '')),
                    // URL: this.shortUrl,
                    OrderID: this.fromReport ? this.CreateOrderModel.OrderID : this.OrderID,
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    TabNumber: this.tabNo
                }
                this.$api.diner.SendPaymentURL(model).then(res => {
                    if (res.success) {
                        this.loading = false
                        this.$emit('finalSendLink', this.tabNo)
                    }
                }).catch(err => {
                    this.loading = false
                })
            },
            cancelOperation () {

                this.$emit('cancelOperation')
            }
        }
    }
</script>

<style scoped>

</style>
